<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-11 p-0 credit-section">
    <div class="container-fluid div-height">

      <div class="row breadcrumbs-section">
        <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
        <img class="separator mt-1" src="../../assets/images/seperator.png">
        <span class="prev-page pl-2 pr-2 " routerLink="/profile">Profile</span>
        <img class="separator mt-1" src="../../assets/images/seperator.png">
        <span [ngClass]="!sucessMsg?'curr-page':'prev-page'" (click)="toggle()" class="pl-2 pr-2">Change password</span>
        <img *ngIf="sucessMsg" class="separator mt-1" src="../../assets/images/seperator.png">
        <span *ngIf="sucessMsg" class="curr-page pl-2 ">Status</span>
      </div>

      <div class="ml-5 pl-3 mt-0 pt-0 mb-5">
        <div class="row">
          <h1 class="col-11">Change Password</h1>

          <div class="log-out d-flex justify-content-end col-1 ">
            <!-- Log Out -->
            <div class="dots pointer-link" (click)="profileDrawer=!profileDrawer">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>
        <div class="drawer" *ngIf="profileDrawer">
          <div class="drawer-label-container">
            <div class='drawer-label' (click)="toggle()">Change Password</div>
            <div class='drawer-label' (click)="logout()">Logout</div>
          </div>
        </div>


        <div *ngIf="!sucessMsg">
          <input class="mt-4" [type]="showOldPassword ? 'text' : 'password'"
            [ngClass]="old?'textbox-onselect':'textbox-style'" [(ngModel)]="oldPassword"
            [placeholder]="!old ? 'Old password' : ''" (click)="enterName('oldPassword')" (blur)="enterName('oldPassword')" required>
          <label *ngIf="old" class="form-lable">Old password</label>
          <img (click)="toggleOldPassword()"
            [src]="showOldPassword?'assets/images/show-password.png':'assets/images/hide-password.png'"
            [ngClass]="old?'form-append-img':'form-append'" loading="lazy" />
          <div>
            <span *ngIf="fieldErrors.includes('oldPwd')" class="error-text">* This field is Mandatory</span>
          </div>
          <br>
          <input class="mt-4" [type]="showNewPassword ? 'text' : 'password'"
            [ngClass]="newpass?'textbox-onselect':'textbox-style'" [(ngModel)]="newPassword"
            [placeholder]="!newpass ? 'New password' : ''" (click)="enterName('newPassword');validatedPwdRegex(1) "
            required pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-#^_+=])[A-Za-z\d@$!%*?&\-#^_+=]{8,}$"
            (blur)="validatedPwdRegex(1);enterName('newPassword')" (keyup)="inputModelChange()">
          <label *ngIf="newpass" class="form-lable">New password</label>
          <img (click)="toggleNewPassword()"
            [src]="showNewPassword?'assets/images/show-password.png':'assets/images/hide-password.png'"
            [ngClass]="newpass?'form-new':'form-append'" loading="lazy" />
          <div>
            <span *ngIf="fieldErrors.includes('newPwd')" class="error-text">* This field is Mandatory</span>
            <span *ngIf="fieldErrors.includes('passOneErr')" class="error-text">Please enter Valid Password</span>

          </div>
          <div class="row" *ngIf="newPassword.length>0">
            <div class="col-3 mr-0">
              <span class="mt-1">Password Strength</span>
              <img src="assets/images/password-strength.png" loading="lazy">
            </div>
            <div class="col-7 ">
              <app-password-strength-bar [passwordToCheck]="newPassword" [barLabel]="barLabel">
              </app-password-strength-bar>
            </div>
          </div>
          <br>

          <input class="mt-4" [type]="showConfirmPassword ? 'text' : 'password'"
            [ngClass]="confirmPass?'textbox-onselect':'textbox-style'" [(ngModel)]="confirmPassword"
            [placeholder]="!confirmPass ? 'confirm password' : ''" (click)="enterName('confirmPassword')" required
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-#^_+=])[A-Za-z\d@$!%*?&\-#^_+=]{8,}$" (blur)="enterName('confirmPassword')" (keyup)="inputModelChange()">
          <label *ngIf="confirmPass" class="form-lable">confirm password</label>
          <img (click)="toggleConfirmPassword()"
            [src]="showConfirmPassword?'assets/images/show-password.png':'assets/images/hide-password.png'"
            [ngClass]="confirmPass?'form-confirm':'form-append'" loading="lazy" />
          <div>
            <span *ngIf="fieldErrors.includes('confirmPwd')" class="error-text">* This field is Mandatory</span>
            <span *ngIf="invalidPasswordMatch" class="error-text">Password did not match</span>
          </div>
          <br>
          <div class="row">
            <span class="error-text col-5"
              *ngIf="setPassForm.controls.newPassword.status == 'INVALID' && passOneErr">Password
              must be minimum
              8
              characters and should
              contain atleast 1
              uppercase, 1 lowercase, a number and a special character</span>
            <span class="col-6"></span>
          </div>

          <button class="btn mt-5" type="submit" (click)="confirm()">Confirm</button>
        </div>
      </div>
    </div>

    <div *ngIf="sucessMsg" style="margin-left: 80px;">
      <img src="../../assets/images/success-tick.png">
      <p class="sucessMsg mt-3 ml-4">Your password has been successfully changed.</p>
    </div>
  </div>
</div>
